import React from "react";
import {
  Box,
  IconButton,
  Paper,
  Tooltip,
  InputAdornment,
  FormControl,
  OutlinedInput,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import InfoIcon from "@mui/icons-material/Info";
import { Link } from "react-router-dom";

import MyBreadcrumbs from "../MyBreadcrumbs";
import GlobalContext from "../../utils/GlobalContext";
import { RENTALS } from "../../graphql/Rental";

const RentalPage = () => {
  let history = useHistory();
  const { setGlobalLoading } = React.useContext(GlobalContext);
  const [rentals, setRentals] = React.useState([]);
  const [rentalsHistory, setRentalsHistory] = React.useState([]);
  const [baseRentals, setBaseRentals] = React.useState([]);
  const [baseRentalsHistory, setBaseRentalsHistory] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [isSearch, setIsSearch] = React.useState(false);
  const [value, setValue] = React.useState(0);

  const columns = [
    {
      field: "id",
      headerName: "Nomor",
      width: 90,
      renderCell: (params) => `${params.api.getRowIndex(params.row.id) + 1}.`,
    },
    {
      field: "name",
      headerName: "Nama Perusahaan",
      width: 250,
    },
    {
      field: "address",
      headerName: "Alamat",
      width: 250,
    },
    {
      field: "pic",
      headerName: "PIC",
      flex: 1,
    },
    {
      field: "phone",
      headerName: "Nomor Telepon",
      flex: 1,
    },
    {
      field: "total_rental",
      headerName: "Jumlah Peminjaman",
      flex: 1,
    },
    {
      field: "oid",
      headerName: "Aksi",
      width: 90,
      renderCell: (params) => {
        const $redir = value === 1 ? "?history=true" : "";

        return (
          <Tooltip title='Detail' placement='top'>
            <IconButton
              aria-label='detail'
              size='small'
              component={Link}
              to={`/admin/rental/${params?.row?.uid}${$redir}`}
              target='__blank'
            >
              <InfoIcon fontSize='inherit' />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const requestSearch = (value) => {
    setSearched(value);
  };

  const clearSearch = () => {
    setSearched("");
    setIsSearch(false);
    setRentals([...baseRentals]);
  };

  const doSearch = async () => {
    setIsSearch(true);
    // const data = await getCompanies({
    //   variables: { name: searched },
    // });

    // setCompany([...data.data?.searchCompanies]);
  };

  /* FETCH DATA COMPANIES */
  const { loading: loadRentals, data: dataRentals } = useQuery(RENTALS, {
    fetchPolicy: "network-only",
    onError: (e) => console.log("error getting selor:", e),
  });

  const { loading: loadRentalsHistory, data: dataRentalsHistory } = useQuery(
    RENTALS,
    {
      fetchPolicy: "network-only",
      variables: { history: true },
      onError: (e) => console.log("error getting selor:", e),
    }
  );

  React.useEffect(() => {
    if (loadRentals) {
      setGlobalLoading(true);
    }
  }, [loadRentals]);

  React.useEffect(() => {
    if (loadRentalsHistory) {
      setGlobalLoading(true);
    }
  }, [loadRentalsHistory]);

  React.useEffect(() => {
    if (dataRentals && !dataRentalsHistory) {
      setBaseRentals(dataRentals.rentals);
      setRentals(dataRentals.rentals);
      setGlobalLoading(false);
      console.log("==> Rentals", dataRentals.rentals);
      debugger;
    }
  }, [dataRentals]);

  React.useEffect(() => {
    if (dataRentalsHistory) {
      setBaseRentalsHistory(dataRentalsHistory.rentals);
      setRentalsHistory(dataRentalsHistory.rentals);
      setGlobalLoading(false);
    }
  }, [dataRentalsHistory]);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    console.log("==> handleChange", value);
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          bgcolor: "background.paper",
          borderRadius: 1,
          alignItems: "center",
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <MyBreadcrumbs data={["Transaksi", "Mesin Fotokopi"]} />
        </Box>
        <Box
          sx={{
            p: 0.5,
            m: 0.5,
          }}
        >
          <FormControl size='small' margin='dense'>
            <OutlinedInput
              name='search'
              margin='dense'
              id='search'
              placeholder='Cari'
              onChange={(e) => requestSearch(e.target.value)}
              value={searched}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  doSearch();
                }
              }}
              endAdornment={
                <InputAdornment position='end'>
                  {isSearch && (
                    <IconButton onClick={() => clearSearch()}>
                      <ClearIcon />
                    </IconButton>
                  )}
                  {!isSearch && (
                    <IconButton onClick={() => doSearch()}>
                      <SearchIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
          </FormControl>
        </Box>
        <Box
          sx={{
            p: 0.5,
            m: 0.5,
          }}
        >
          <Tooltip title='Tambah' placement='top'>
            <IconButton
              aria-label='add'
              size='small'
              onClick={() => history.push("/admin/rental/new")}
              style={{
                backgroundColor: "#1976d2",
                color: "white",
                marginRight: 10,
              }}
            >
              <AddIcon fontSize='inherit' />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='basic tabs example'
        >
          <Tab label='Ongoing' {...a11yProps(0)} />
          <Tab label='History' {...a11yProps(2)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <div style={{ height: 400, width: "100%" }}>
            <DataGrid
              rows={rentals}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              disableSelectionOnClick
            />
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <div style={{ height: 400, width: "100%" }}>
            <DataGrid
              rows={rentalsHistory}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              disableSelectionOnClick
            />
          </div>
        </TabPanel>
      </Paper>
    </React.Fragment>
  );
};

export default RentalPage;
